import { TDishesAction, DishesActionTypes } from './dishesActions';
import { IDishesState } from './dishesContext';

export const dishesReducer = (state: IDishesState, action: TDishesAction): IDishesState => {
	switch (action.type) {
		case DishesActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case DishesActionTypes.SET_DISHES_BY_CUSTOMER:
			return {
				...state,
				dishesByCustomer: action.payload.dishesByCustomer,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				dishesByRestaurant: { totalCount: 0, items: [] },
			};
		case DishesActionTypes.SET_DISHES_BY_RESTAURANT:
			return {
				...state,
				dishesByRestaurant: action.payload.dishesByRestaurant,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				dishesByCustomer: { totalCount: 0, items: [] },
			};
		case DishesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case DishesActionTypes.TOGGLE_REMEMBER_MY_CHOICE:
			return {
				...state,
				rememberMyChoice: action.payload.rememberMyChoice,
			};
		case DishesActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case DishesActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				dishesByCustomer: action.payload.dishesByCustomer,
				dishesByRestaurant: action.payload.dishesByRestaurant,
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubcategory: null,
				isDisabled: null,
				assigned: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				isDisabled: action.payload.isDisabled,
				assigned: action.payload.assigned,
				IDSelectedCategory: null,
				IDSelectedSubcategory: null,
				currentPage: 1,
			};
		case DishesActionTypes.TOGGLE_IS_DISABLED: {
			return {
				...state,
				isDisabled: action.payload.isDisabled,
				currentPage: 1,
			};
		}
		case DishesActionTypes.TOGGLE_ASSIGNED:
			return {
				...state,
				assigned: !state.assigned,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
				IDSelectedSubcategory: null,
				currentPage: 1,
			};
		case DishesActionTypes.SET_ID_SUBCATEGORY:
			return {
				...state,
				IDSelectedSubcategory: action.payload.IDSelectedSubcategory,
				currentPage: 1,
			};
		case DishesActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRestaurant: null,
				IDSelectedCategory: null,
				IDSelectedSubcategory: null,
				isDisabled: null,
				assigned: false,
				currentPage: 1,
			};
		case DishesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case DishesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case DishesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case DishesActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS:
			return {
				...state,
				IDForAssignRestaurants: action.payload.IDForAssignRestaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE:
			return {
				...state,
				IDForEditModGroupTemplate: action.payload.IDForEditModGroupTemplate,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishesActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
				isInitializedSelectCustomerModal: true,
			};
		default:
			return state;
	}
};
